<template>
    <luma-empty >
      <b-card>
        <b-button class="col-12"
                  @click="apiCallPermission()"
                  variant="outline-success">Benutzer erstellen</b-button>
      </b-card>
      <b-modal id="createUser" v-if="getPermissions && permissionsC" >
        <h1>{{$t('account.users.title')}}</h1>
        <b-form-group>
          <b-form-group v-for="(item,key) in newUser"
                        :key="key"
                        :label="$t('account.users')[item['key']]">
            <b-form-input :id="item"
                          v-model="userData[item.key]"
                          :type="item.key === 'password' || item.key === 'password_confirm' ? 'password' : 'text' "></b-form-input>
          </b-form-group>
          <h1>{{$t('account.rights.title')}}</h1>
          <div  v-for="(item,key) in getPermissions">
            <h3>
              <b-link @click=" permissionGroup === key ? permissionGroup = '' : permissionGroup = key">{{$t('account.rights')[key]}}</b-link>
              <b-badge v-if="groupSetting[key]"
                       class="float-right"
                       variant="danger">
                {{$t('account.rights.all_selected')}}
              </b-badge>
              <b-badge v-if="permissionsC[key].length &&  !groupSetting[key] "
                       class="float-right"
                       variant="warning">
                checked
              </b-badge>
            </h3>
            <b-form-group v-show="permissionGroup === key">
              <b-checkbox @change="selectAllPermissions(key) , $forceUpdate()">{{$t('account.rights.select_all')}}</b-checkbox>
              <b-checkbox-group stacked
                                v-if="!groupSetting[key]"
                                v-model="permissionsC[key]"
                                :options="getPermissions[key].map(el=>el.title)">
<!--                <b-form-checkbox v-for="(i,k) in item"-->
<!--                                 :value="i.key">-->
<!--                  {{i.title}}-->
<!--                </b-form-checkbox>-->
              </b-checkbox-group>
            </b-form-group>
          </div>
        </b-form-group>
        <template v-slot:modal-footer>
          <b-button class="col-12"
                    :variant="passwordValidation ? 'outline-success' : 'danger'  "
                    :disabled="passwordValidation ? false : true"
                    @click="saveNewUser()">
            {{ passwordValidation ? $t('account.users.password_valid') : $t('account.users.password_hint') }}
          </b-button>
        </template>
      </b-modal>

      <luma-account-list></luma-account-list>


    </luma-empty>
</template>

<script>
    import LumaEmpty from "@/layout/LumaEmpty";
    import LumaAccountList from "@/components/account/details_account/luma-account-list";
    import {ApiRoutesModel} from "@/store/models/layout/api_routes";
    import {ApiRoutesModelMixin} from "@/mixins/api_routes_model__mixin";
    import {User} from "@/store/models/user";
    import {GetPermissions} from "@/store/models/account/account_get_permissions";

    export default {
        name: "account-view",
        components: {LumaAccountList, LumaEmpty},
        mixins:[ApiRoutesModelMixin],
        data:()=>({
            userData:{},
            permissions:{},
            permissionGroup:'',
            getPermissions:{},
            groupSetting:{},
        }),

        computed:{
            rawResponsePermissions(){
                const x = GetPermissions.all()
                return x
            },
            passwordValidation(){
                if(!this.userData.password) return false
                if(this.userData.password.length < 8) return false
                let x = false
                switch (this.userData.password){
                    case this.userData.password_confirm: x =  true
                    default: false
                }
                return x
            },
            newUser(){
                return [
                    {key:'username'},
                    {key:'email'},
                    {key:'password'},
                    {key:'password_confirm'}
                ]
            },
            permissionsC(){
                if(!this.permissions) return
                return this.permissions
            }
        },
        methods:{

          apiCallPermission(){
              const categories = new Set(this.rawResponsePermissions.map(el=>(el['category'])))
              const perms = {}
              const cat = Array.from(categories)
              console.log('1111', cat)
              const x = cat.map(el=>{
                perms[el]=new Array
                this.permissions[el]= new Array
                this.groupSetting[el]= false
              })
              console.log('1111', cat)
              const y = this.rawResponsePermissions.map(el=>{
                perms[el.category].push(el)
              })
              this.getPermissions = perms
              return this.$bvModal.show('createUser')
          },
            selectAllPermissions(key){
                this.groupSetting[key] = !this.groupSetting[key]
                !this.groupSetting[key]  ? this.permissions[key] = new Array
                                        : this.permissions[key] = this.getPermissions[key].map(el=>el.key)
                return
            },
            saveNewUser(){
              let permissions = []
              const x = Object.keys(this.permissionsC).map(el=>{
                  this.permissionsC[el].map(el=>{
                      permissions.push(el)
                    })}
              )
              const postrequestData = {
                  username:this.userData.username,
                  password:this.userData.password,
                  email:this.userData.email,
                  permissions:permissions
              }
              this.$bvModal.hide('createUser')
              console.log('SAVE NEW USER',postrequestData)
              const post = ApiRoutesModel.getResponseData("post.account.user.create",postrequestData,User,'user')
              this.$forceUpdate()
          }
        },
        created(){
            const x = GetPermissions.fetchPermissions()
        }

        // created(){
        //     localStorage.removeItem('user_permissions')
        //     const gp = ApiRoutesModel.getResponseData('get.permissions')['response']['permissions']
        //     localStorage.setItem('getpermissions',JSON.stringify(gp))
        // },
        // mounted(){
        //     this.rawResponsePermissions = GetPermissions.all()
        // }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/account/details_account/account-view-v0.vue